export default class otherConst {
  static timeZones = [
    { preview: 'ET', value: 'ET' },
    { preview: 'CT', value: 'CT' },
    { preview: 'MT', value: 'MT' },
    { preview: 'PT', value: 'PT' },
  ];

  static cities = [
    { preview: 'New York', value: 'New York' },
    {
      preview: 'Los Angeles',
      value: 'Los Angeles',
    },
    { preview: 'Chicago', value: 'Chicago' },
  ];

  static countries = [
    { preview: 'United States', value: 'US' },
    { preview: 'Afghanistan', value: 'AF' },
    { preview: 'Åland Islands', value: 'AX' },
    { preview: 'Albania', value: 'AL' },
    { preview: 'Algeria', value: 'DZ' },
    { preview: 'American Samoa', value: 'AS' },
    { preview: 'AndorrA', value: 'AD' },
    { preview: 'Angola', value: 'AO' },
    { preview: 'Anguilla', value: 'AI' },
    { preview: 'Antarctica', value: 'AQ' },
    { preview: 'Antigua and Barbuda', value: 'AG' },
    { preview: 'Argentina', value: 'AR' },
    { preview: 'Armenia', value: 'AM' },
    { preview: 'Aruba', value: 'AW' },
    { preview: 'Australia', value: 'AU' },
    { preview: 'Austria', value: 'AT' },
    { preview: 'Azerbaijan', value: 'AZ' },
    { preview: 'Bahamas', value: 'BS' },
    { preview: 'Bahrain', value: 'BH' },
    { preview: 'Bangladesh', value: 'BD' },
    { preview: 'Barbados', value: 'BB' },
    { preview: 'Belarus', value: 'BY' },
    { preview: 'Belgium', value: 'BE' },
    { preview: 'Belize', value: 'BZ' },
    { preview: 'Benin', value: 'BJ' },
    { preview: 'Bermuda', value: 'BM' },
    { preview: 'Bhutan', value: 'BT' },
    { preview: 'Bolivia', value: 'BO' },
    { preview: 'Bosnia and Herzegovina', value: 'BA' },
    { preview: 'Botswana', value: 'BW' },
    { preview: 'Bouvet Island', value: 'BV' },
    { preview: 'Brazil', value: 'BR' },
    { preview: 'British Indian Ocean Territory', value: 'IO' },
    { preview: 'Brunei Darussalam', value: 'BN' },
    { preview: 'Bulgaria', value: 'BG' },
    { preview: 'Burkina Faso', value: 'BF' },
    { preview: 'Burundi', value: 'BI' },
    { preview: 'Cambodia', value: 'KH' },
    { preview: 'Cameroon', value: 'CM' },
    { preview: 'Canada', value: 'CA' },
    { preview: 'Cape Verde', value: 'CV' },
    { preview: 'Cayman Islands', value: 'KY' },
    { preview: 'Central African Republic', value: 'CF' },
    { preview: 'Chad', value: 'TD' },
    { preview: 'Chile', value: 'CL' },
    { preview: 'China', value: 'CN' },
    { preview: 'Christmas Island', value: 'CX' },
    { preview: 'Cocos (Keeling) Islands', value: 'CC' },
    { preview: 'Colombia', value: 'CO' },
    { preview: 'Comoros', value: 'KM' },
    { preview: 'Congo', value: 'CG' },
    { preview: 'Congo, The Democratic Republic of the', value: 'CD' },
    { preview: 'Cook Islands', value: 'CK' },
    { preview: 'Costa Rica', value: 'CR' },
    { preview: 'Cote D"Ivoire', value: 'CI' },
    { preview: 'Croatia', value: 'HR' },
    { preview: 'Cuba', value: 'CU' },
    { preview: 'Cyprus', value: 'CY' },
    { preview: 'Czech Republic', value: 'CZ' },
    { preview: 'Denmark', value: 'DK' },
    { preview: 'Djibouti', value: 'DJ' },
    { preview: 'Dominica', value: 'DM' },
    { preview: 'Dominican Republic', value: 'DO' },
    { preview: 'Ecuador', value: 'EC' },
    { preview: 'Egypt', value: 'EG' },
    { preview: 'El Salvador', value: 'SV' },
    { preview: 'Equatorial Guinea', value: 'GQ' },
    { preview: 'Eritrea', value: 'ER' },
    { preview: 'Estonia', value: 'EE' },
    { preview: 'Ethiopia', value: 'ET' },
    { preview: 'Falkland Islands (Malvinas)', value: 'FK' },
    { preview: 'Faroe Islands', value: 'FO' },
    { preview: 'Fiji', value: 'FJ' },
    { preview: 'Finland', value: 'FI' },
    { preview: 'France', value: 'FR' },
    { preview: 'French Guiana', value: 'GF' },
    { preview: 'French Polynesia', value: 'PF' },
    { preview: 'French Southern Territories', value: 'TF' },
    { preview: 'Gabon', value: 'GA' },
    { preview: 'Gambia', value: 'GM' },
    { preview: 'Georgia', value: 'GE' },
    { preview: 'Germany', value: 'DE' },
    { preview: 'Ghana', value: 'GH' },
    { preview: 'Gibraltar', value: 'GI' },
    { preview: 'Greece', value: 'GR' },
    { preview: 'Greenland', value: 'GL' },
    { preview: 'Grenada', value: 'GD' },
    { preview: 'Guadeloupe', value: 'GP' },
    { preview: 'Guam', value: 'GU' },
    { preview: 'Guatemala', value: 'GT' },
    { preview: 'Guernsey', value: 'GG' },
    { preview: 'Guinea', value: 'GN' },
    { preview: 'Guinea-Bissau', value: 'GW' },
    { preview: 'Guyana', value: 'GY' },
    { preview: 'Haiti', value: 'HT' },
    { preview: 'Heard Island and Mcdonald Islands', value: 'HM' },
    { preview: 'Holy See (Vatican City State)', value: 'VA' },
    { preview: 'Honduras', value: 'HN' },
    { preview: 'Hong Kong', value: 'HK' },
    { preview: 'Hungary', value: 'HU' },
    { preview: 'Iceland', value: 'IS' },
    { preview: 'India', value: 'IN' },
    { preview: 'Indonesia', value: 'ID' },
    { preview: 'Iran, Islamic Republic Of', value: 'IR' },
    { preview: 'Iraq', value: 'IQ' },
    { preview: 'Ireland', value: 'IE' },
    { preview: 'Isle of Man', value: 'IM' },
    { preview: 'Israel', value: 'IL' },
    { preview: 'Italy', value: 'IT' },
    { preview: 'Jamaica', value: 'JM' },
    { preview: 'Japan', value: 'JP' },
    { preview: 'Jersey', value: 'JE' },
    { preview: 'Jordan', value: 'JO' },
    { preview: 'Kazakhstan', value: 'KZ' },
    { preview: 'Kenya', value: 'KE' },
    { preview: 'Kiribati', value: 'KI' },
    { preview: 'Korea, Democratic People"S Republic of', value: 'KP' },
    { preview: 'Korea, Republic of', value: 'KR' },
    { preview: 'Kuwait', value: 'KW' },
    { preview: 'Kyrgyzstan', value: 'KG' },
    { preview: 'Lao People"S Democratic Republic', value: 'LA' },
    { preview: 'Latvia', value: 'LV' },
    { preview: 'Lebanon', value: 'LB' },
    { preview: 'Lesotho', value: 'LS' },
    { preview: 'Liberia', value: 'LR' },
    { preview: 'Libyan Arab Jamahiriya', value: 'LY' },
    { preview: 'Liechtenstein', value: 'LI' },
    { preview: 'Lithuania', value: 'LT' },
    { preview: 'Luxembourg', value: 'LU' },
    { preview: 'Macao', value: 'MO' },
    { preview: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
    { preview: 'Madagascar', value: 'MG' },
    { preview: 'Malawi', value: 'MW' },
    { preview: 'Malaysia', value: 'MY' },
    { preview: 'Maldives', value: 'MV' },
    { preview: 'Mali', value: 'ML' },
    { preview: 'Malta', value: 'MT' },
    { preview: 'Marshall Islands', value: 'MH' },
    { preview: 'Martinique', value: 'MQ' },
    { preview: 'Mauritania', value: 'MR' },
    { preview: 'Mauritius', value: 'MU' },
    { preview: 'Mayotte', value: 'YT' },
    { preview: 'Mexico', value: 'MX' },
    { preview: 'Micronesia, Federated States of', value: 'FM' },
    { preview: 'Moldova, Republic of', value: 'MD' },
    { preview: 'Monaco', value: 'MC' },
    { preview: 'Mongolia', value: 'MN' },
    { preview: 'Montserrat', value: 'MS' },
    { preview: 'Morocco', value: 'MA' },
    { preview: 'Mozambique', value: 'MZ' },
    { preview: 'Myanmar', value: 'MM' },
    { preview: 'Namibia', value: 'NA' },
    { preview: 'Nauru', value: 'NR' },
    { preview: 'Nepal', value: 'NP' },
    { preview: 'Netherlands', value: 'NL' },
    { preview: 'Netherlands Antilles', value: 'AN' },
    { preview: 'New Caledonia', value: 'NC' },
    { preview: 'New Zealand', value: 'NZ' },
    { preview: 'Nicaragua', value: 'NI' },
    { preview: 'Niger', value: 'NE' },
    { preview: 'Nigeria', value: 'NG' },
    { preview: 'Niue', value: 'NU' },
    { preview: 'Norfolk Island', value: 'NF' },
    { preview: 'Northern Mariana Islands', value: 'MP' },
    { preview: 'Norway', value: 'NO' },
    { preview: 'Oman', value: 'OM' },
    { preview: 'Pakistan', value: 'PK' },
    { preview: 'Palau', value: 'PW' },
    { preview: 'Palestinian Territory, Occupied', value: 'PS' },
    { preview: 'Panama', value: 'PA' },
    { preview: 'Papua New Guinea', value: 'PG' },
    { preview: 'Paraguay', value: 'PY' },
    { preview: 'Peru', value: 'PE' },
    { preview: 'Philippines', value: 'PH' },
    { preview: 'Pitcairn', value: 'PN' },
    { preview: 'Poland', value: 'PL' },
    { preview: 'Portugal', value: 'PT' },
    { preview: 'Puerto Rico', value: 'PR' },
    { preview: 'Qatar', value: 'QA' },
    { preview: 'Reunion', value: 'RE' },
    { preview: 'Romania', value: 'RO' },
    { preview: 'Russian Federation', value: 'RU' },
    { preview: 'RWANDA', value: 'RW' },
    { preview: 'Saint Helena', value: 'SH' },
    { preview: 'Saint Kitts and Nevis', value: 'KN' },
    { preview: 'Saint Lucia', value: 'LC' },
    { preview: 'Saint Pierre and Miquelon', value: 'PM' },
    { preview: 'Saint Vincent and the Grenadines', value: 'VC' },
    { preview: 'Samoa', value: 'WS' },
    { preview: 'San Marino', value: 'SM' },
    { preview: 'Sao Tome and Principe', value: 'ST' },
    { preview: 'Saudi Arabia', value: 'SA' },
    { preview: 'Senegal', value: 'SN' },
    { preview: 'Serbia and Montenegro', value: 'CS' },
    { preview: 'Seychelles', value: 'SC' },
    { preview: 'Sierra Leone', value: 'SL' },
    { preview: 'Singapore', value: 'SG' },
    { preview: 'Slovakia', value: 'SK' },
    { preview: 'Slovenia', value: 'SI' },
    { preview: 'Solomon Islands', value: 'SB' },
    { preview: 'Somalia', value: 'SO' },
    { preview: 'South Africa', value: 'ZA' },
    { preview: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { preview: 'Spain', value: 'ES' },
    { preview: 'Sri Lanka', value: 'LK' },
    { preview: 'Sudan', value: 'SD' },
    { preview: 'Suriname', value: 'SR' },
    { preview: 'Svalbard and Jan Mayen', value: 'SJ' },
    { preview: 'Swaziland', value: 'SZ' },
    { preview: 'Sweden', value: 'SE' },
    { preview: 'Switzerland', value: 'CH' },
    { preview: 'Syrian Arab Republic', value: 'SY' },
    { preview: 'Taiwan, Province of China', value: 'TW' },
    { preview: 'Tajikistan', value: 'TJ' },
    { preview: 'Tanzania, United Republic of', value: 'TZ' },
    { preview: 'Thailand', value: 'TH' },
    { preview: 'Timor-Leste', value: 'TL' },
    { preview: 'Togo', value: 'TG' },
    { preview: 'Tokelau', value: 'TK' },
    { preview: 'Tonga', value: 'TO' },
    { preview: 'Trinidad and Tobago', value: 'TT' },
    { preview: 'Tunisia', value: 'TN' },
    { preview: 'Turkey', value: 'TR' },
    { preview: 'Turkmenistan', value: 'TM' },
    { preview: 'Turks and Caicos Islands', value: 'TC' },
    { preview: 'Tuvalu', value: 'TV' },
    { preview: 'Uganda', value: 'UG' },
    { preview: 'Ukraine', value: 'UA' },
    { preview: 'United Arab Emirates', value: 'AE' },
    { preview: 'United Kingdom', value: 'GB' },
    { preview: 'United States Minor Outlying Islands', value: 'UM' },
    { preview: 'Uruguay', value: 'UY' },
    { preview: 'Uzbekistan', value: 'UZ' },
    { preview: 'Vanuatu', value: 'VU' },
    { preview: 'Venezuela', value: 'VE' },
    { preview: 'Viet Nam', value: 'VN' },
    { preview: 'Virgin Islands, British', value: 'VG' },
    { preview: 'Virgin Islands, U.S.', value: 'VI' },
    { preview: 'Wallis and Futuna', value: 'WF' },
    { preview: 'Western Sahara', value: 'EH' },
    { preview: 'Yemen', value: 'YE' },
    { preview: 'Zambia', value: 'ZM' },
    { preview: 'Zimbabwe', value: 'ZW' },
  ];

  static states = [
    {
      preview: 'Alabama',
      value: 'AL',
    },
    {
      preview: 'Alaska',
      value: 'AK',
    },
    {
      preview: 'Arizona',
      value: 'AZ',
    },
    {
      preview: 'Arkansas',
      value: 'AR',
    },
    {
      preview: 'California',
      value: 'CA',
    },
    {
      preview: 'Colorado',
      value: 'CO',
    },
    {
      preview: 'Connecticut',
      value: 'CT',
    },
    {
      preview: 'Delaware',
      value: 'DE',
    },
    {
      preview: 'Florida',
      value: 'FL',
    },
    {
      preview: 'Georgia',
      value: 'GA',
    },
    {
      preview: 'Hawaii',
      value: 'HI',
    },
    {
      preview: 'Idaho',
      value: 'ID',
    },
    {
      preview: 'Illinois',
      value: 'IL',
    },
    {
      preview: 'Indiana',
      value: 'IN',
    },
    {
      preview: 'Iowa',
      value: 'IA',
    },
    {
      preview: 'Kansas',
      value: 'KS',
    },
    {
      preview: 'Kentucky',
      value: 'KY',
    },
    {
      preview: 'Louisiana',
      value: 'LA',
    },
    {
      preview: 'Maine',
      value: 'ME',
    },
    {
      preview: 'Maryland',
      value: 'MD',
    },
    {
      preview: 'Massachusetts',
      value: 'MA',
    },
    {
      preview: 'Michigan',
      value: 'MI',
    },
    {
      preview: 'Minnesota',
      value: 'MN',
    },
    {
      preview: 'Mississippi',
      value: 'MS',
    },
    {
      preview: 'Missouri',
      value: 'MO',
    },
    {
      preview: 'Montana',
      value: 'MT',
    },
    {
      preview: 'Nebraska',
      value: 'NE',
    },
    {
      preview: 'Nevada',
      value: 'NV',
    },
    {
      preview: 'New Hampshire',
      value: 'NH',
    },
    {
      preview: 'New Jersey',
      value: 'NJ',
    },
    {
      preview: 'New Mexico',
      value: 'NM',
    },
    {
      preview: 'New York',
      value: 'NY',
    },
    {
      preview: 'North Carolina',
      value: 'NC',
    },
    {
      preview: 'North Dakota',
      value: 'ND',
    },
    {
      preview: 'Ohio',
      value: 'OH',
    },
    {
      preview: 'Oklahoma',
      value: 'OK',
    },
    {
      preview: 'Oregon',
      value: 'OR',
    },
    {
      preview: 'Pennsylvania',
      value: 'PA',
    },
    {
      preview: 'Rhode Island',
      value: 'RI',
    },
    {
      preview: 'South Carolina',
      value: 'SC',
    },
    {
      preview: 'South Dakota',
      value: 'SD',
    },
    {
      preview: 'Tennessee',
      value: 'TN',
    },
    {
      preview: 'Texas',
      value: 'TX',
    },
    {
      preview: 'Utah',
      value: 'UT',
    },
    {
      preview: 'Vermont',
      value: 'VT',
    },
    {
      preview: 'Virginia',
      value: 'VA',
    },
    {
      preview: 'District of Columbia',
      value: 'DC',
    },
    {
      preview: 'Washington',
      value: 'WA',
    },
    {
      preview: 'West Virginia',
      value: 'WV',
    },
    {
      preview: 'Wisconsin',
      value: 'WI',
    },
    {
      preview: 'Wyoming',
      value: 'WY',
    },
  ];

  static statesMap = {
    Alabama: 'AL',
    Alaska: 'AK',
    Arizona: 'AZ',
    Arkansas: 'AR',
    California: 'CA',
    Colorado: 'CO',
    Connecticut: 'CT',
    Delaware: 'DE',
    Florida: 'FL',
    Georgia: 'GA',
    Hawaii: 'HI',
    Idaho: 'ID',
    Illinois: 'IL',
    Indiana: 'IN',
    Iowa: 'IA',
    Kansas: 'KS',
    Kentucky: 'KY',
    Louisiana: 'LA',
    Maine: 'ME',
    Maryland: 'MD',
    Massachusetts: 'MA',
    Michigan: 'MI',
    Minnesota: 'MN',
    Mississippi: 'MS',
    Missouri: 'MO',
    Montana: 'MT',
    Nebraska: 'NE',
    Nevada: 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    Ohio: 'OH',
    Oklahoma: 'OK',
    Oregon: 'OR',
    Pennsylvania: 'PA',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    Tennessee: 'TN',
    Texas: 'TX',
    Utah: 'UT',
    Vermont: 'VT',
    Virginia: 'VA',
    Washington: 'WA',
    'West Virginia': 'WV',
    Wisconsin: 'WI',
    Wyoming: 'WY',
  };

  static credit_rating = [
    { value: "Don't know", preview: "Don't know" },
    { value: '639 and below', preview: '639 and below' },
    { value: '640-679', preview: '640-679' },
    { value: '680-699', preview: '680-699' },
    { value: '700-739', preview: '700-739' },
    { value: '740 and above', preview: '740 and above' },
  ];
}
